import axios from 'axios'
import Requester from './Requester'

export const apiLimitReturned = 10

export const requesterStockMethods = {
  GET_CAR: 'getCar',
  GET_CARS: 'getCars',
  GET_BODIES: 'get_bodies',
  GET_BRANDS: 'getMakes',
  GET_MODELS: 'getModels',
  GET_FUELS: 'getFuels',
  GET_TRANSMISSIONS: 'get_transmissions',
  GET_INIT_FILTERS: 'get_init_filters'
}

/**
 * The Request class allows you to centralize calls to the outside of the application, including the server
 */
class RequesterStock extends Requester {
  /**
   * Réalise des appels vers l'API
   *
   * @param {string} action le nom de l'action à réaliser
   * @param {*} params un objet de paramètres
   * @static
   * @return {Promise} une promesse en général avec les données de retour
   */
  static get = (action, params, redirectMessage, addParamsEntityPOS) => {
    if (action === requesterStockMethods.GET_CAR) {
      const { id } = params

      return RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: `/vehicles/cars/${id}`,
        params: {},
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterStockMethods.GET_CARS) {
      return RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars',
        params,
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterStockMethods.GET_BODIES) {
      return RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/bodies',
        params,
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterStockMethods.GET_BRANDS) {
      return RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/makes',
        params,
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterStockMethods.GET_MODELS) {
      return RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/models',
        params,
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterStockMethods.GET_FUELS) {
      return RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/fuels',
        params,
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterStockMethods.GET_TRANSMISSIONS) {
      return RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/transmissions',
        params,
        redirectMessage,
        addParamsEntityPOS
      })
    }

    if (action === requesterStockMethods.GET_INIT_FILTERS) {
      const requestMakes = RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/makes',
        params,
        redirectMessage,
        addParamsEntityPOS
      })

      const requestModels = RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/models',
        params,
        redirectMessage,
        addParamsEntityPOS
      })

      const requestBodies = RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/bodies',
        params,
        redirectMessage,
        addParamsEntityPOS
      })

      const requestFuels = RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/fuels',
        params,
        redirectMessage,
        addParamsEntityPOS
      })

      const requestTransmissions = RequesterStock.getRequest({
        urlApi: 'urlSelling',
        url: '/vehicles/cars/transmissions',
        params,
        redirectMessage,
        addParamsEntityPOS
      })

      const requests = [
        requestMakes,
        requestModels,
        requestBodies,
        requestFuels,
        requestTransmissions
      ]

      return new Promise((resolve, reject) => {
        axios
          .all(requests)
          .then(
            axios.spread(
              (
                requestMakesResponse,
                requestModelsResponse,
                requestBodiesResponse,
                requestFuelsResponse,
                requestTransmissionsResponse
              ) => {
                if (requestMakesResponse.error) {
                  if (requestMakesResponse.error.message) reject(requestMakesResponse.error.message)

                  reject(requestMakesResponse.error)
                }

                if (requestModelsResponse.error) {
                  if (requestModelsResponse.error.message)
                    reject(requestModelsResponse.error.message)

                  reject(requestModelsResponse.error)
                }

                if (requestBodiesResponse.error) {
                  if (requestBodiesResponse.error.message)
                    reject(requestBodiesResponse.error.message)

                  reject(requestBodiesResponse.error)
                }

                if (requestFuelsResponse.error) {
                  if (requestFuelsResponse.error.message) reject(requestFuelsResponse.error.message)

                  reject(requestFuelsResponse.error)
                }
                if (requestTransmissionsResponse.error) {
                  if (requestTransmissionsResponse.error.message)
                    reject(requestTransmissionsResponse.error.message)

                  reject(requestTransmissionsResponse.error)
                }

                const response = {
                  makes: requestMakesResponse.makes,
                  models: requestModelsResponse.models,
                  bodies: requestBodiesResponse.bodies,
                  fuels: requestFuelsResponse.fuels,
                  transmissions: requestTransmissionsResponse.transmissions
                }

                resolve(response)
              }
            )
          )
          .catch(error => {
            reject(error)
          })
      })
    }

    return null
  }
}

export default RequesterStock
